import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  scrollToTop(): void {
    const scrollContainer = document.querySelector('mat-sidenav-content');
    if (scrollContainer) {
      scrollContainer.scrollTo(0, 0);
      return;
    }

    window.scrollTo(0, 0);
  }

  scrollToSection(sectionId: string): void {
    const sectionAnchor = document.getElementById(sectionId);
    if (!sectionAnchor) {
      return;
    }

    sectionAnchor.scrollIntoView({ block: 'start' });
  }
}
